const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/some_aps/EmptyRouterView.vue");
const SomeHome = () => /* webpackChunkName: "Home" */ import("./../views/some_aps/Home.vue");
const SomeAps = () => /* webpackChunkName: "SomeAps" */ import("./../views/some_aps/telemedical/SomeAps.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/administrative/archive_request/ArchiveRequestHome.vue");
const PatientManager = () => /* webpackChunkName: "PatientHome" */ import("./../views/some_aps/patient/PatientHome.vue");
const Interconsults = () => /* webpackChunkName: "InterconsultHome" */ import("./../views/some_aps/interconsult/InterconsultHome.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/someAps",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "someApsHome",
        component: SomeHome,
      },
      {
        path: "interconsulta-some-aps",
        name: "someApsTic",
        component: SomeAps,
      },
      {
        path: "solicitud-archivo",
        name: "someApsArchiveRequest",
        component: ArchiveRequest,
      },
      {
        path: "gestion-paciente",
        name: "someApsPatientManager",
        component: PatientManager,
      },
      {
        path: "interconsultas",
        name: "someApsInterconsults",
        component: Interconsults,
      },
      {
        path: "documentacion",
        name: "someApsDocumentation",
        component: Document,
      },
    ],
  },
];
